import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

const AddGiftCardButton = ({
    onClick,
    left,
    right,
    classNames: { button, label },
}) => {
    const [t] = useTranslation('gift-card');
    return (
        <button
            type="button"
            title={t('title_add_card')}
            onClick={onClick}
            className={button}
        >
            {left}
            <span className={label}>{t('title_add_card')}</span>
            {right}
        </button>
    );
};

AddGiftCardButton.defaultProps = {
    left: undefined,
    right: undefined,
    classNames: {
        button: '',
        label: '',
    },
};

AddGiftCardButton.propTypes = {
    onClick: PropTypes.func.isRequired,
    left: PropTypes.element,
    right: PropTypes.element,
    classNames: PropTypes.shape({
        button: PropTypes.string,
        label: PropTypes.string,
    }),
};

export default AddGiftCardButton;
